
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/sharps-disposal",
      function () {
        return require("private-next-pages/sharps-disposal/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/sharps-disposal"])
      });
    }
  